<template>
  <div class="body-custom">
    <b-card class="card-custom">
      <b-col>
        <b-col class="mb-4">
          <h1 class="text-primary">Signup</h1>
          <p>Explore opportunities. Sign up now.</p>
        </b-col>
        <div v-if="step === 1">
          <h5 class="">Personal Details</h5>
          <b-row>
            <b-form-group label="First Name" class="col-md-6">
              <b-form-input
                v-model="firstName"
                placeholder="Enter First Name"
                :class="getFieldClass('firstName')"
                required
              />
            </b-form-group>
            <b-form-group label="Last Name" class="col-md-6">
              <b-form-input
                v-model="lastName"
                placeholder="Enter Last Name"
                :class="getFieldClass('lastName')"
                required
              />
            </b-form-group>
            <b-form-group label="Gender" class="col-md-6">
              <b-form-select
                v-model="gender"
                :options="genderOptions"
                placeholder="Select"
                :class="getFieldClass('gender')"
                required
              />
            </b-form-group>
            <b-form-group label="Birthdate" class="col-md-6">
              <b-form-input
                v-model="birthdate"
                type="date"
                :class="getFieldClass('birthdate')"
                required
              />
            </b-form-group>
            <b-form-group label="Country" class="col-md-6">
              <b-form-select
                v-model="selectedCountry"
                :options="countries"
                :class="getFieldClass('selectedCountry')"
                required
              />
            </b-form-group>
            <b-form-group
              v-if="selectedCountry === 'philippines'"
              label="City"
              class="col-md-6"
            >
              <b-form-select
                v-model="selectedCity"
                required
                :class="getFieldClass('selectedCity')"
                :options="cities"
              />
            </b-form-group>
            <b-form-group v-else label="City" class="col-md-6">
              <b-form-input
                v-model="city"
                :class="getFieldClass('city')"
                placeholder="Enter City Name"
                required
              />
            </b-form-group>
            <b-form-group label="Contact Number" class="col-md-6">
              <b-form-input
                v-model="contactNumber"
                type="number"
                :class="getFieldClass('contactNumber')"
                placeholder="Enter Contact Number"
                required
              />
            </b-form-group>
            <b-form-group label="Contact Number Type" class="col-md-6">
              <b-form-select
                v-model="contactNumberType"
                :options="contactNumberTypeOptions"
                :class="getFieldClass('contactNumberType')"
                required
              />
            </b-form-group>
          </b-row>
        </div>
        <div v-if="step === 2">
          <h5 class="">Work Details</h5>
          <b-row>
            <b-form-group label="Industry" class="col-md-6">
              <b-form-select
                v-model="industry"
                required
                :class="getFieldClass('industry')"
                :options="industry_options"
              />
            </b-form-group>
            <b-form-group label="Function" class="col-md-6">
              <b-form-select
                v-model="industry_function"
                :options="function_options"
                :class="getFieldClass('industry_function')"
                required
              />
            </b-form-group>
            <b-form-group label="Brand" class="col-md-6">
              <b-form-select
                v-model="brand"
                :options="brand_options"
                :class="getFieldClass('brand')"
                required
              />
            </b-form-group>
            <b-form-group label="Current Company" class="col-md-6">
              <b-form-input
                v-model="current_company"
                placeholder="Enter Current Company"
                :class="getFieldClass('current_company')"
                required
              />
            </b-form-group>
            <b-form-group label="Current Role" class="col-md-6">
              <b-form-input
                v-model="current_role"
                placeholder="Enter Current Role"
                :class="getFieldClass('current_role')"
                required
              />
            </b-form-group>
            <b-form-group label="Current Salary" class="col-md-6">
              <b-form-input
                v-model="current_salary"
                placeholder="Enter Current Salary"
                type="number"
                :class="getFieldClass('current_salary')"
                required
              />
            </b-form-group>
            <b-form-group label="Expected Salary" class="col-md-6">
              <b-form-input
                v-model="expected_salary"
                placeholder="Enter Expected Salary"
                type="number"
                :class="getFieldClass('expected_salary')"
                required
              />
            </b-form-group>
            <b-form-group label="Tags" class="col-md-6">
              <b-form-select
                v-model="tag"
                :options="tagsOptions"
                required
                :class="getFieldClass('tag')"
              />
            </b-form-group>
            <b-form-group label="Source" class="col-md-6">
              <b-form-select
                v-model="source"
                :options="source_options"
                :class="getFieldClass('source')"
                required
              />
            </b-form-group>
            <b-form-group label="Link" class="col-md-6">
              <b-form-input
                v-model="link"
                placeholder="Enter Link"
                required
                :class="getFieldClass('link')"
              />
            </b-form-group>
          </b-row>
          <b-form-group label="Work Experience">
            <b-form-select
              v-model="work_experience"
              :options="workExperienceOptions"
              required
              :class="getFieldClass('work_experience')"
            />
          </b-form-group>
          <b-form-group label="Summary">
            <b-form-textarea v-model="summary" placeholder="Enter Summary" />
          </b-form-group>
        </div>
        <div v-if="step === 3">
          <h5 class="">Account Settings</h5>
          <b-form-group label="Email Address">
            <b-form-input v-model="email" placeholder="Enter Email Address"   :class="getFieldClass('email')"/>
          </b-form-group>
          <b-form-group label="Password">
            <b-form-input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              :class="getFieldClass('password')"
              placeholder="Enter Password"
            />
          </b-form-group>
          <b-form-group label="Confirm Password">
            <b-form-input
              v-model="confirmPassword"
              :type="showPassword ? 'text' : 'password'"
              :class="getFieldClass('confirmPassword')"
              placeholder="Re-type your password"
            />
          </b-form-group>
          <b-form-checkbox v-model="showPassword">
            Show Password
          </b-form-checkbox>
        </div>
      </b-col>
      <div class="d-flex flex-row-reverse">
        <b-button
          v-if="step === 1 || step === 2"
          variant="primary"
          @click="nextStep"
        >
          Next
          <b-icon-arrow-right-circle class="ml-2"></b-icon-arrow-right-circle>
        </b-button>
        <b-button v-if="step === 3" variant="primary" @click="submitForm">
          Sign Up
          <b-icon-arrow-right-circle class="ml-2"></b-icon-arrow-right-circle>
        </b-button>
        <b-button
          v-if="step === 1"
          variant="light"
          class="mr-2"
          @click="cancel"
        >
          Cancel
        </b-button>
        <b-button
          v-if="step > 1"
          variant="secondary"
          class="mr-2"
          @click="step--"
        >
          <b-icon-arrow-left-circle class="mr-2"></b-icon-arrow-left-circle>
          Back
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import cities from "philippines/cities";
export default {
  name: "UserSignup",
  data() {
    return {
      step: 1,
      showPassword: false,
      firstName: "",
      lastName: "",
      email: "",
      birthdate: "",
      gender: "",
      genderOptions: [
        { value: "male", text: "Male" },
        { value: "female", text: "Female" },
      ],
      contactNumberTypeOptions: [
        { value: "mobile", text: "Mobile" },
        { value: "home", text: "Home" },
        { value: "work", text: "Work" },
      ],
      contactNumber: "",
      contactNumberType: "",
      countries: [
        { value: "philippines", text: "Philippines" },
        { value: "other", text: "Other" },
      ],
      selectedCountry: "",
      selectedCity: "",
      cities: [],
      city: "",
      current_company: "",
      current_role: "",
      current_salary: "",
      expected_salary: "",
      tag: "",
      source: "",
      link: "",
      work_experience: "",
      summary: "",
      password: "",
      confirmPassword: "",
      validationErrors: {},
      tagsOptions: [
        { value: "tag1", text: "Tag 1" },
        { value: "tag2", text: "Tag 2" },
      ],
      workExperienceOptions: [
        { value: "0-1", text: "0-1 years" },
        { value: "1-3", text: "1-3 years" },
        { value: "3+", text: "3+ years" },
      ],
      industry_options: [],
      function_options: [],
      source_options: [],
      industry: "",
      industry_function: "",
      brand_options: [],
      brand: "",
    };
  },
  async created() {
    const recruiter = this.$route.query.recruiter;
    const recruiter_id = {recruiter_id: recruiter};
    await this.$store.dispatch("user_signup/check_recruiter", recruiter_id ).then(res =>{
      if(!res.data.recruiter){
        this.$router.push('/404');
      }
    });
    this.loadCities();
    // Fetch data for industries
    try {
      const res = await this.$store.dispatch("user_signup/getIndustry");
      if (res && res.data) {
        this.industry_options = res.data.map((el) => ({
          value: el._id,
          text: el.name,
        }));
      }
    } catch (e) {
      console.error("Failed to fetch industries:", e);
    }
    // Fetch data for functions
    try {
      const function_data = await this.$store.dispatch(
        "user_signup/getFunction"
      );
      if (function_data && function_data.data) {
        this.function_options = function_data.data.map((el) => ({
          value: el._id,
          text: el.name,
        }));
      }
    } catch (e) {
      console.error("Failed to fetch functions:", e);
    }
    // Fetch data for brands
    try {
      const brand_data = await this.$store.dispatch("user_signup/getBrand");
      if (brand_data && brand_data.data) {
        this.brand_options = brand_data.data.map((el) => ({
          value: el._id,
          text: el.name,
        }));
      }
    } catch (e) {
      console.error("Failed to fetch brands:", e);
    }
    // Fetch data for sources
    try {
      const source_data = await this.$store.dispatch(
        "user_signup/getCandidateSource"
      );
      if (source_data && source_data.data) {
        this.source_options = source_data.data.map((el) => ({
          value: el._id,
          text: el.name,
        }));
      }
    } catch (e) {
      console.error("Failed to fetch sources:", e);
    }
  },
  methods: {
    loadCities() {
      this.cities = cities.map((city) => ({
        value: city.name,
        text: city.name,
      }));
    },
    getFieldClass(field) {
      return this.validationErrors[field] ? "border border-danger" : "";
    },
    nextStep() {
      if (this.validateSteps()) {
        this.step++;
      } 
      // this.step++;
    },
    cancel() {
      this.$router.push({ name: "login" });
    },
    submitForm() {
     if(this.validateSteps()){
      const recruiter = this.$route.query.recruiter;
      const payload = {
        recruiter_id: recruiter,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        birthdate: this.birthdate,
        gender: this.gender,
        contact_no: this.contactNumber,
        contact_type: this.contactNumberType,
        country: this.selectedCountry,
        city:
          this.selectedCountry === "philippines"
            ? this.selectedCity
            : this.city,
        current_company: this.current_company,
        current_role: this.current_role,
        current_salary: this.current_salary,
        expected_salary: this.expected_salary,
        tag: this.tag,
        source: this.source,
        link: this.link,
        work_experience: this.work_experience,
        summary: this.summary,
        password: this.password,
        access_type: "candidate",
        function_id: this.industry_function,
        industry_id: this.industry,
        brand_id: this.brand,
      };

      try {
        this.$store.dispatch('user_signup/create', payload)
        .then(res => {
          if(res){
            this.newUser();
          }
        })
        .catch(err => {
          console.error('Signup error:', err);
          
          const message = err.response?.data?.message || "Something went wrong during signup.";

          this.$bvToast.toast(message, {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
      } catch (e) {
        console.log("Error submitting form:", e);
        this.$bvToast.toast(
          "There was an error submitting the form. Please try again.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
        return;
      }
     }
    
    },
    validateSteps() {
      this.validationErrors = {}; // Reset

      if (this.step === 1) {
        const allEmpty =
          !this.firstName &&
          !this.lastName &&
          !this.gender &&
          !this.birthdate &&
          !this.selectedCountry &&
          !this.selectedCity &&
          !this.city &&
          !this.contactNumber &&
          !this.contactNumberType;

        if (allEmpty) {
          this.$bvToast.toast(
            "Please fill out all required fields in Step 1.",
            {
              title: "Missing Information",
              variant: "danger",
              solid: true,
            }
          );
          return false;
        }

        if (!this.firstName) {
          this.validationErrors.firstName = "First Name is required";
        }
        if (!this.lastName) {
          this.validationErrors.lastName = "Last Name is required";
        }
        if (!this.gender) {
          this.validationErrors.gender = "Gender is required";
        }
        if (!this.birthdate) {
          this.validationErrors.birthdate = "Birthdate is required";
        }
        if (!this.selectedCountry) {
          this.validationErrors.selectedCountry = "Country is required";
        }
        if (this.selectedCountry === "philippines" && !this.selectedCity) {
          this.validationErrors.selectedCity = "City is required";
        } else if (this.selectedCountry !== "philippines" && !this.city) {
          this.validationErrors.city = "City is required";
        }
        if (!this.contactNumber) {
          this.validationErrors.contactNumber = "Contact number is required";
        }
        if (!this.contactNumberType) {
          this.validationErrors.contactNumberType = "Contact type is required";
        }
    
      } else if (this.step === 2) {
        const allEmpty =
          !this.industry &&
          !this.industry_function &&
          !this.brand &&
          !this.current_company &&
          !this.current_role &&
          !this.current_salary &&
          !this.expected_salary &&
          !this.tag &&
          !this.source &&
          !this.link;
        if (allEmpty) {
          this.$bvToast.toast(
            "Please fill out all required fields in Step 2.",
            {
              title: "Missing Information",
              variant: "danger",
              solid: true,
            }
          );
          return false;
        }

        if (!this.current_company) {
          this.validationErrors.current_company = "Current Company is required";
        }
        if (!this.current_role) {
          this.validationErrors.current_role = "Current Role is required";
        }
        if (!this.current_salary) {
          this.validationErrors.current_salary = "Current Salary is required";
        }
        if (!this.expected_salary) {
          this.validationErrors.expected_salary = "Expected Salary is required";
        }
        if (!this.tag) {
          this.validationErrors.tag = "Tag is required";
        }
        if (!this.source) {
          this.validationErrors.source = "Source is required";
        }
        if (!this.link) {
          this.validationErrors.link = "link is required";
        }

      } else if (this.step === 3) {
        if (!this.email || this.email.trim() === "") {
          this.validationErrors.email = "Email is required";
        }
        if (!this.password) {
          this.validationErrors.password = "Password is required";
        }
        if (!this.confirmPassword) {
          this.validationErrors.confirmPassword = "Confirm Password is required";
        }
        if (this.password !== this.confirmPassword) {
          this.validationErrors.password = true;
          this.validationErrors.confirmPassword = true;
          this.$bvToast.toast(
            "There was an error verifying your password. Please check that both entries are the same.",
            {
              title: "Password Mismatch",
              variant: "danger",
              solid: true,
            }
          );
          return false;
        }
      }

      const errors = Object.values(this.validationErrors);
      if (errors.length > 0) {
        errors.forEach((msg) => {
          this.$bvToast.toast(msg, {
            title: "Validation Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 4000,
          });
        });
        return false;
      }else{
        return true;
      }
    },
  },
};
</script>

<style scoped>
.body-custom {
  background-image: url("../../../assets/images/building-bg.jpg"); /* or relative path */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  padding: 0;
}
.card-custom {
  width: 650px;
  padding: 20px;
}
.card-body {
  overflow-y: auto;
  max-height: 80vh;
}
</style>
